var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle209(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "68.11999999999999 597.8290257894186 20.64635250164838 24.48241012992753",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M72.13,611.2c.39-1.72.59-3.64,1.26-5.38,1.3-3.36,4.87-4.84,7.9-3.5,3.33,1.47,4.47,5.2,2.53,8.63-.93,1.65-1.95,3.28-3.17,4.71-.82.97-1.98,1.77-3.15,2.3-2.03.91-3.84,0-4.45-2.12-.42-1.45-.6-2.96-.93-4.64Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle209);
export default __webpack_public_path__ + "static/media/twinkle-2-09.d6874518395455a43d907400a782b802.svg";
export { ForwardRef as ReactComponent };